/**
 * Collection chip filters on /collections/all (current page of products).
 */
const ROOT_SELECTOR = '[data-bz-shop-all-filters]';
const GRID_SELECTOR = '.product-grid__item[data-bz-collections]';
const COUNT_SELECTOR = '.template-collection [data-testid="products-count"] [role="status"]';

function parseHandles(value) {
  if (!value) return [];
  return value.split(',').map((h) => h.trim()).filter(Boolean);
}

function initShopAllFilters(root) {
  const pills = root.querySelectorAll('[data-bz-collection-filter]');
  const items = document.querySelectorAll(GRID_SELECTOR);
  const hint = root.querySelector('[data-bz-collection-hint]');
  const viewLink = root.querySelector('[data-bz-collection-view-link]');
  const countNodes = document.querySelectorAll(COUNT_SELECTOR);

  if (!pills.length || !items.length) return;

  const setActivePill = (handle) => {
    document.querySelectorAll('[data-bz-collection-filter]').forEach((pill) => {
      const isActive = pill.getAttribute('data-bz-collection-filter') === handle;
      pill.classList.toggle('bz-shop-all-filters__pill--active', isActive);
      pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const countOne = root.getAttribute('data-count-one') ?? '';
  const countOther = root.getAttribute('data-count-other') ?? '';
  const viewNamedTemplate = root.getAttribute('data-view-collection') ?? '';

  const updateCount = (visible) => {
    if (!countOne && !countOther) return;
    const label =
      visible === 1
        ? countOne
        : countOther.replace(/\{\{\s*count\s*\}\}/g, String(visible));
    countNodes.forEach((node) => {
      node.textContent = label;
    });
  };

  const applyFilter = (handle, collectionUrl, collectionTitle) => {
    let visible = 0;

    items.forEach((item) => {
      const handles = parseHandles(item.getAttribute('data-bz-collections'));
      const show = handle === 'all' || handles.includes(handle);
      item.hidden = !show;
      if (show) visible += 1;
    });

    if (hint) {
      hint.hidden = handle === 'all';
    }

    if (viewLink && collectionUrl) {
      viewLink.href = collectionUrl;
      if (collectionTitle && viewNamedTemplate) {
        viewLink.textContent = viewNamedTemplate.replace('__NAME__', collectionTitle);
      }
      viewLink.classList.toggle('visually-hidden', handle === 'all');
    }

    updateCount(visible);
  };

  const onPillClick = (pill) => {
    const handle = pill.getAttribute('data-bz-collection-filter');
    const url = pill.getAttribute('data-bz-collection-url');
    const title =
      pill.getAttribute('data-bz-collection-title')?.trim() ||
      pill.textContent?.trim() ||
      '';
    setActivePill(handle);
    applyFilter(handle, url, title);
  };

  document.querySelectorAll('[data-bz-collection-filter]').forEach((pill) => {
    pill.addEventListener('click', () => onPillClick(pill));
  });
}

function boot() {
  document.querySelectorAll(ROOT_SELECTOR).forEach(initShopAllFilters);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}

document.addEventListener('shopify:section:load', boot);
